// src/pages/Parametros/mock/parametrosDefault.js
export const PARAMETROS_DEFAULT = {
    tempo: {
        tempoMinimoExecucao: 10,
        bloqueioAntesDoMinimo: true,
        mensagemDadosInsuficientes: 'Dados insuficientes para análise',
    },
    temperatura: {
        temperaturaProtocolo: 36,
        tolerancia: 2,
    },
    crescimento: {
        modoAnalise: 'presence_absence',
        ativarDetectorCombinado: true,
        percentualMinimoConsenso: 50,
        minimosPontosPorSerie: 5,
        tamanhoJanelaMovingAverage: 20,
        sigmaSmoothing: 1.0,
        direcaoEsperada: 'auto',
    },
    metricas: {
        coliformesTotais: {
            sensor: 'turbidimetry',
            canal: 'F2',
            limiarAmplitude: 5,
            limiarRatio: 1.05,
        },
        ecoli: {
            sensor: 'fluorescence',
            canal: 'F2',
            limiarAmplitude: 20,
            limiarRatio: 1.25,
        },
    },
    duplicata: {
        limiteMuitoBoa: 2,
        limiteAceitavel: 5,
        limiteAtencao: 100,
        acaoEmInconsistencia: 'repetir_analise',
    },
    relatorio: {
        validarCtMaiorQueEcoli: true,
        validarEficienciaPositiva: true,
        validarEficienciaMaiorQue20: true,
        marcarAlertaEmInconsistencia: true,
    },
    cor: [
        { tipoGrafico: 'SPECTRAL_TURBIDIMETRY', ativarValidacaoCor: true, minPontosValidos: 10, minVarianciaCor: 5 },
        { tipoGrafico: 'SPECTRAL_NEPHELOMETRY',  ativarValidacaoCor: true, minPontosValidos: 10, minVarianciaCor: 5 },
        { tipoGrafico: 'SPECTRAL_FLUORESCENCE',  ativarValidacaoCor: true, minPontosValidos: 10, minVarianciaCor: 5 },
    ],
};
